export const PencilIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      clipPath="url(#clip0_19723_14802)"
    >
      <path d="m14.616 8.433-3.05-3.05M5.21 17.5H2.5v-2.708c0-.221.087-.434.244-.59L13.856 3.09a.83.83 0 0 1 1.178 0l1.876 1.876a.83.83 0 0 1 0 1.178L5.798 17.257a.83.83 0 0 1-.589.244"></path>
    </g>
    <defs>
      <clipPath id="clip0_19723_14802">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
